import { shouldEnableLocalDevFeatures } from "@/store/appEnvironment";

const DEV_LOCALE_STORAGE_KEY = "scorecards-dev-locale";
const SUPPORTED_APP_LOCALES = ["en", "es"];

function isDevLocaleSwitcherEnabled() {
  return shouldEnableLocalDevFeatures();
}

function normalizeAppLocale(locale) {
  return SUPPORTED_APP_LOCALES.includes(locale) ? locale : null;
}

function getStoredDevLocale() {
  if (!isDevLocaleSwitcherEnabled()) {
    return null;
  }

  try {
    return normalizeAppLocale(localStorage.getItem(DEV_LOCALE_STORAGE_KEY));
  } catch {
    return null;
  }
}

function persistDevLocale(locale) {
  if (!isDevLocaleSwitcherEnabled()) {
    return;
  }

  const normalizedLocale = normalizeAppLocale(locale);
  if (!normalizedLocale) {
    return;
  }

  try {
    localStorage.setItem(DEV_LOCALE_STORAGE_KEY, normalizedLocale);
  } catch {
    // Ignore storage failures in restricted browser contexts.
  }
}

function getNextSupportedLocale(locale) {
  return locale === "en" ? "es" : "en";
}

export {
  getNextSupportedLocale,
  getStoredDevLocale,
  isDevLocaleSwitcherEnabled,
  persistDevLocale,
  SUPPORTED_APP_LOCALES,
};
